import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import emailjs from 'emailjs-com';
import '../style.css';

function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    emailjs.send('service_9lb5qor', 'template_lbosaog', data, 'E34tJabSp_CQoJAQZ')
      .then(() => alert("Tu formulario ha sido enviado exitosamente."))
      .catch(() => alert("Hubo un error al enviar tu formulario. Intenta nuevamente."));
  };

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Contacto | Culturlingua — Tlaquepaque y Online</title>
        <meta name="description" content="Contáctanos para información sobre cursos de inglés presenciales y online en Culturlingua Tlaquepaque." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Estamos aquí</div>
        <h1>Contáctanos</h1>
        <p>A través de nuestros diferentes canales. Respondemos en menos de 1 hora.</p>
      </div>

      <section className="contact-section" style={{paddingTop:'80px'}}>
        <div className="contact-inner">

          <div className="contact-left">
            <div className="section-tag">Información</div>
            <h2 className="section-headline">Hablemos de<br /><em>tus metas</em></h2>
            <p className="section-sub">
              ¿Dudas entre Online o Presencial? ¿No sabes tu nivel? Te orientamos sin compromiso.
            </p>
            <div className="contact-info-items">
              <div className="contact-info-item">
                <div className="contact-info-icon">📍</div>
                <div className="contact-info-text">
                  <strong>Dirección</strong>
                  <span>Reforma 31, Tlaquepaque, Jalisco, México</span>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">📞</div>
                <div className="contact-info-text">
                  <strong>Teléfono</strong>
                  <span>+52 33 3344 9139</span>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">📧</div>
                <div className="contact-info-text">
                  <strong>Correo</strong>
                  <span>administracion@culturlingua.com</span>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">💬</div>
                <div className="contact-info-text">
                  <strong>WhatsApp</strong>
                  <a href="https://wa.me/5213333449139" target="_blank" rel="noopener noreferrer" style={{color:'var(--blue)', textDecoration:'none'}}>
                    Escríbenos →
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <form onSubmit={handleSubmit}>
              <div className="form-row" style={{marginBottom:'16px'}}>
                <div className="form-field" style={{marginBottom:0}}>
                  <label className="form-label">Nombre</label>
                  <input className="form-input" type="text" name="nombre" placeholder="Tu nombre" required />
                </div>
                <div className="form-field" style={{marginBottom:0}}>
                  <label className="form-label">WhatsApp</label>
                  <input className="form-input" type="tel" name="telefono" placeholder="+52 33..." required />
                </div>
              </div>
              <div className="form-field">
                <label className="form-label">Correo electrónico</label>
                <input className="form-input" type="email" name="correo" placeholder="tu@correo.com" required />
              </div>
              <div className="form-field">
                <label className="form-label">¿En qué podemos ayudarte?</label>
                <textarea className="form-input form-textarea" name="pregunta" placeholder="Cuéntanos tu situación..." required></textarea>
              </div>
              <button type="submit" className="form-submit">Enviar Mensaje →</button>
            </form>
          </div>

        </div>
      </section>

      <section style={{background:'var(--cream)', padding:'60px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.790690850651!2d-103.31288652577223!3d20.637386701107793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b3b317ea78ef%3A0xa00c5f440c6b46b3!2sCulturlingua!5e0!3m2!1sen!2smx!4v1738696722222!5m2!1sen!2smx"
            width="100%" height="420"
            style={{border:0, borderRadius:'16px', display:'block'}}
            allowFullScreen loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
}

export default Contact;
